import React from 'react';
import PropTypes from 'prop-types';
import Thumbnail from '../Thumbnail/Thumbnail';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { LAYOUTS } from 'store/modules/video-layout';
import { FILMSTRIP_TYPE } from 'store/modules/filmstrip';
const Filmstrip = (props) => {
  const { deviceParticipants, remoteParticipants } = props;
  return (
    <div className="filmstrip__videos" id="remoteVideos">
      <div className="filmstrip__videos filmstrip__videos-scrollable remote-videos">
        {remoteParticipants.map((item) => (
          <Thumbnail
            _currentLayout={LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW}
            filmstripType={FILMSTRIP_TYPE.MAIN}
            key={`remote_${item}`}
            participantID={item}
          />
        ))}
      </div>
      <div className="filmstrip__videos filmstrip__videos-scrollable remote-videos">
        {deviceParticipants.map((item) => (
          <Thumbnail
            _currentLayout={LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW}
            filmstripType={FILMSTRIP_TYPE.MAIN}
            key={`remote_${item}`}
            participantID={item}
          />
        ))}
      </div>
    </div>
  );
};
export default React.memo(withBoundary(Filmstrip));
Filmstrip.propTypes = {
  remoteParticipants: PropTypes.array,
  deviceParticipants: PropTypes.array
};
